import { render, staticRenderFns } from "./BookingsClosed.vue?vue&type=template&id=6cdbca46&"
import script from "./BookingsClosed.vue?vue&type=script&lang=js&"
export * from "./BookingsClosed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports